module.exports = __webpack_public_path__ + "assets/31.jpg?dc3a67a46b75eb59e7b56b0351d346a6";